import { render, staticRenderFns } from "./CardDayOfTheWeek.vue?vue&type=template&id=9cf6b618&scoped=true&"
import script from "./CardDayOfTheWeek.vue?vue&type=script&lang=js&"
export * from "./CardDayOfTheWeek.vue?vue&type=script&lang=js&"
import style0 from "./CardDayOfTheWeek.vue?vue&type=style&index=0&id=9cf6b618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf6b618",
  null
  
)

export default component.exports